/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useMask, useGLTF } from '@react-three/drei'
import Bird from './Bird.jsx'

export default function Birds({invert, ...props}) {
  const { nodes, materials } = useGLTF('./birds.glb')

  const stencil = useMask(1, invert)

    const stencilMaterials = [
        materials.bird_body,
        materials.bird_wings,
        materials.yellow,
        materials.eyes,
        materials.bird_beak
    ]

    stencilMaterials.forEach(mat => {
        mat.stencilWrite = stencil.stencilWrite
        mat.stencilRef = stencil.stencilRef
        mat.stencilFunc = stencil.stencilFunc
    })

  return (
    <group {...props} dispose={null}>
        <Bird nodes={nodes} materials={materials} position={[1.185, 1.117, -2.359]} rotation={[0, -0.476, 0]}/>
        <Bird nodes={nodes} materials={materials} position={[-0.514, 5.33, -1.881]} rotation={[0.349, 0.148, -0.079]}/>
        <Bird nodes={nodes} materials={materials}  position={[-1.84, 1.525, -1.702]} rotation={[0.078, 0.174, 0.179]}/>
    </group>
  )
}

useGLTF.preload('./birds.glb')